import React, { useContext, useEffect, useState, useRef } from "react";
import SocketContext from "../../../../../context/SocketContext";

export default function LivePl({ item, LivePlTotal }) {
  const socket = useContext(SocketContext);
  const [pf, setPf] = useState(0);
  const lastPfRef = useRef(0);

  const calculatePL = (data) => {
    if (!data || !item) return 0;

    const bid = parseFloat(data.Bid) || 0;
    const ask = parseFloat(data.Ask) || 0;
    const ltp = parseFloat(data.LTP) || 0;
    const rate = parseFloat(item.rate) || 0;
    const qty = parseFloat(item.qty) || 0;
    const dollarRate = parseFloat(item.dollar_rate) || 1;
    const rupee_dollar = parseFloat(item.rupee_dollar);

    let profit = 0;

    if (item.buy_sell === 0) {
      // 🟢 Buy position
      const price = bid > 0 ? bid : ltp > 0 ? ltp : 0;
      profit = (price - rate) * qty;
    } else if (item.buy_sell === 1) {
      // 🔴 Sell position
      const price = ask > 0 ? ask : ltp > 0 ? ltp : 0;
      profit = (rate - price) * qty;
    }

    // ✅ Apply dollar_rate for specific types
    if (rupee_dollar === 0) {
      if (
        item.type === "comex_future" ||
        item.type === "crypto_future" ||
        item.type === "forex_future" ||
        item.type === "us_stock" ||
        item.type === "index" ||
        item.type === "dgcx"
      ) {
        profit *= dollarRate;
      }
    }

    return profit;
  };

  // ✅ Socket event handler
  useEffect(() => {
    if (!socket || !item?.symbol_id) return;

    const eventName = "trade" + item.symbol_id;

    const handleTrade = (data) => {
      const pl = calculatePL(data);
      setPf(pl);
    };

    socket.emit("giverate", item.symbol_id);
    socket.on(eventName, handleTrade);

    return () => {
      socket.off(eventName, handleTrade);
    };
  }, [socket, item?.symbol_id]);

  // ✅ Calculate admin share
  const net_admin_sharing =
    (parseFloat(pf) * parseFloat(item.admin_sharing || 0)) / 100;

  // ✅ Only send updates if P/L changes
  useEffect(() => {
    if (!item?.id) return;
    if (lastPfRef.current === pf) return;
    lastPfRef.current = pf;

    LivePlTotal(item.id, pf, net_admin_sharing);
  }, [pf, item?.id, net_admin_sharing, LivePlTotal]);

  return <div key={item.id} />;
}
